class InterAppCom {
  status = null;
  allowOrigin = null;
  targetOrigin = null;
  target = null;
  callback = null;

  /**
   *
   * @param allowOrigin {string}
   * @param targetOrigin {string}
   * @param target {HTMLElement}
   * @param callback {function}
   */
  constructor(allowOrigin, targetOrigin, target, callback) {
    this.allowOrigin = allowOrigin;
    this.targetOrigin = targetOrigin;
    this.target = target;
    this.callback = callback;

    this.eventSubscribe();
  }

  eventSubscribe() {
    this.evenMessageHandler = this.receiveMessage.bind(this);
    window.addEventListener("message", this.evenMessageHandler);
  }

  /**
   *
   * @param data {object|string}
   */
  sendMessage(data) {
    switch (typeof data) {
      case "object":
        try {
          this.target.postMessage(JSON.stringify(data), this.targetOrigin);
        } catch (e) {
          this.target.postMessage(JSON.stringify(data), this.allowOrigin);
        }
        break;
      case "string":
        try {
          this.target.postMessage(data, this.targetOrigin);
        } catch (e) {
          this.target.postMessage(data, this.allowOrigin);
        }
        break;
      default:
        console.log("Not supported data for sending");
    }
  }

  /**
   *
   * @param e {object}
   */
  receiveMessage(e) {
    if (e.origin === this.allowOrigin) {
      this.callback(JSON.parse(e.data));
    }
  }

  cleanUp() {
    return window.removeEventListener("message", this.evenMessageHandler);
  }
}

export default InterAppCom;
